const ADD_CST_PIS_CONFIS = "ADD_CST_PIS_CONFIS";
const GET_ALL_CST_PIS_CONFIS = "GET_ALL_CST_PIS_CONFIS";



module.exports = {
    ADD_CST_PIS_CONFIS,
    GET_ALL_CST_PIS_CONFIS,
}
